export const headBody8 = {
    "bone_controllers": [
        {
            "name": "legs_length_long",
            "value": 0.6
        },
        {
            "name": "waist_length_long",
            "value": 0.4
        },
        {
            "name": "neck_length_long",
            "value": 0.2
        },
        {
            "name": "head_size_small",
            "value": 0.4
        },
        {
            "name": "arms_length_long",
            "value": 0.65
        },
        {
            "name": "waist_thickness_thick",
            "value": 0.4
        },
        {
            "name": "arms_thickness_thick",
            "value": 0.15
        },
        {
            "name": "legs_thickness_thick",
            "value": 0.2
        }
    ],
}
